"use client";

import Image from "next/image";
import { useEffect, useState } from "react";
import { getTradingPair } from "@/service/api";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const CoinUpdate = () => {
  const [pairs, setPairs] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  useEffect(() => {
    fetchTradingPairs();
  }, [""]);

  const fetchTradingPairs = async () => {
    // setIsLoading(true);
    let params: any = {
      page: 1,
      sizePerPage: 100,
      pagination: false,
    };

    try {
      const response = await getTradingPair(params);
      if (response.status) {
        setPairs(response?.data?.result);
      }
    } catch (error) {
      console.error("Error fetching pairs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    // slidesToScroll: 70,
    pauseOnHover: true,
    // speed: 80000,
    slidesToShow: 6, // Show 3 cards at a time
    slidesToScroll: 1,
    autoplay: true,
    cssEase: "linear",
    autoplaySpeed: 1000, // Change slide every 3 seconds
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <section className="w-full">
      <div className="container-wrapper px-4 sm:px-6 lg:px-12 mx-auto flex flex-col gap-3 mt-[41px]">
        {/* Header */}
        {/* <div className="w-full flex flex-wrap justify-center gap-2 items-center text-center">
          <span className="text-black text-red-400 text-[18px] font-outfit">
            Featured
          </span>
          <span className="text-textGreen text-[18px] font-outfit">
            crypto coins
          </span>
        </div> */}

        <div className="w-full flex justify-center text-center text-[28px] sm:text-[36px] md:text-[40px] font-outfit font-bold flex-row gap-2 items-center">
          Top Crypto Updates
        </div>

        {/* Cards Grid */}
        <div className="w-full mt-7">
          <Slider {...settings}>
            {pairs?.map((crypto: any, index: any) => (
              <div key={index} className="px-2">
                <Cards cryptoList={[crypto]} />
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </section>
  );
};

export default CoinUpdate;

const Cards = ({ cryptoList }: any) => {
  return (
    <div
      className="w-full flex gap-6 justify-start overflow-scroll scrollbar-hide"
      // style={{
      //   gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))",
      // }}
    >
      {cryptoList?.map((item: any, index: number) => (
        <div
          key={index}
          className="bg-white border rounded-xl aspect-square max-w-[180px] w-full mx-auto p-4 flex flex-col justify-between"
        >
          <div>
            <h6 className="text-[14px] text-smallText font-medium">
              {item?.fromCoin?.symbol} / {item?.toCoin?.symbol}
            </h6>
          </div>

          <div className="w-10 h-10 rounded-full flex justify-center items-center">
            <Image
              onContextMenu={(e) => e.preventDefault()}
              src={item?.fromCoin?.image}
              alt={"img"}
              width={20}
              height={20}
              className="w-6 h-6 sm:w-7 sm:h-7 object-cover"
            />
          </div>

          <div>
            <h6 className="text-[15px] sm:text-[16px] text-black font-semibold">
              {item?.fromCoin?.name}
            </h6>
          </div>

          <div>
            <h6 className="text-[13px] sm:text-[14px] text-[#000]">
              {item?.toCoin?.symbol === "INR" ||
              item?.toCoin?.symbol === "Inr" ||
              item?.toCoin?.symbol === "inr"
                ? "₹"
                : "$"}
              {item?.currentPrice}
            </h6>
          </div>
        </div>
      ))}
    </div>
  );
};
